import React from 'react';
import Header from '../layout/Header';
import Sidebar from '../layout/Sidebar';
import Footer from '../layout/Footer';
import Breadcrumbs from '../Reusables/Breadcrumbs';
import { useNavigate,useLocation } from "react-router-dom";
import { useEffect, useState } from 'react';
import getWebsite from '../actions/Website';
import SearchSection from '../Reusables/SearchSection';
import { parseBreadcrumbsList } from '../../store/Actions';
import { useDispatch } from 'react-redux';
import edit from '../../images/common/edit.png';
import trash from '../../images/common/trash.png';
import editDark from '../../images/common/edit-dark.png';
import trashDark from '../../images/common/trash-dark.png';
import starpiEdit from '../../images/common/strapi-edit.png';
import starpiEditDark from '../../images/common/strapi-edit-dark.png';
import upsort from '../../images/common/upsort.png';
import downsort from '../../images/common/downsort.png';
import '../../scss/websites.scss';
import DeleteItem from '../popups/DeleteItem';
import Cookies from 'js-cookie'
import RefreshToken from '../actions/RefreshToken';
import axios from 'axios';
import Spinner from '../Reusables/Spinner';
import { useSelector } from 'react-redux';
import EnableDNS from '../popups/EnableDNS';
import Tooltip from "@material-ui/core/Tooltip";
import Strapi from '../actions/Strapi';
import { convertUTCToPST } from '../Reusables/Function';

function Websites(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const CMS_BASE_URL = Strapi();
    const [downloadtype, setDownloadtype] = useState('');
    const[isLoading, setLoading] = useState(true);
    const[rolelist, setRoleList] = useState([]);
    const [downloadList, setDownloadList] = useState([]);
    const [show, setShow] = useState(false);
    const [deleteProjectId, setDeleteProjectId] = useState(null);
    const [deleteproject, setDeleteproject] = useState('');
    const [issort, setSort] = useState(false);
    const [redirUrl, setRedirectUrl] = useState([]);
    const email = useSelector((state) => state.email);
    const signalRConnection = useSelector((state) => state.connection);
    const filename = 'Websites';
    const [isCreated, setCreate] = useState(false);
    const [isUpdatedWeb, setUpdateWeb] = useState(false);
    const [isDeletedWeb, setDeleteWeb] = useState(false);
    const[checkedState, setCheckedState] = useState(null);
    const [isEditted, setEditted] = useState(false);
    const [redirect, setRedirect] = useState(null);
    const userRole = useSelector((state) => state.role);
    const [tableHeaders, setTableHeaders] = useState(null);
    const [searchValues, setSearchValues] = useState({
        isFilter: false,
        isCreate: true,
        placeholder: "Search Sites",
    })
    const [sortValues, setSortValues] = useState({
        sortBy: null,
        sortType: null
    })
    const breadcrumbsList = [
        { "name": "Home", "url": "" },
        { "name": "Websites", "url": "websites/list" }
    ];
    const headers = [
        { label: "Site Name", key: "siteName" },
        { label: "Site Url", key: "siteUrl" },
        { label: "Last Login", key: "lastLogin" },
    ];  

    const addDarkImage = (e, index) => {
        const editElement = document.getElementById('edit'+index)
        const trashElement = document.getElementById('trash'+index)
        const strapiEditElement = document.getElementById('strapi-edit'+index)
        if(editElement && trashElement) {
            editElement.src = editDark;
            trashElement.src = trashDark;
            strapiEditElement.src = starpiEditDark
        }
    }

    const removeDarkImage = (e, index) => {
        const editElement = document.getElementById('edit'+index)
        const trashElement = document.getElementById('trash'+index)
        const strapiEditElement = document.getElementById('strapi-edit'+index)
        if(editElement && trashElement) {
            editElement.src = edit;
            trashElement.src = trash;
            strapiEditElement.src = starpiEdit;
        }
    }

    const handleSort = (dataset) => {
        setSortValues({
            sortBy: dataset.sortBy,
            sortType: dataset.sortType
        })
        const params = new URLSearchParams(location.search);
        const search = params.has('search') ? params.get('search') : '';
        navigate(`/websites/list?${search ? `&search=${search}`: ''}&sort=${dataset.sortBy}&sort_order=${dataset.sortType}`);
        setSort(!issort)
    }

    const handleClose = () => {
        setShow(false);
    }

    const handleShow = () => {
        setShow(true);
    }

    function deleteContact() {
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getWebsite.DeleteWebsite(`/api/websites/${deleteProjectId}`, accesstoken, (data) => {
                    if (data.status == 200) {
                        console.log("Delete Brand", data.data.data);
                        handleClose();
                        setDeleteproject(deleteProjectId);
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                })
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    useEffect(() => {
        // Receiving the signalR response after creating the website
        signalRConnection.on("WebsiteCreate", function (webId, created) {
            setCreate(webId);
        });

        // Receiving the signalR response after editing the website
        signalRConnection.on("WebsiteUpdate", function (webId, created) {
            setUpdateWeb(webId);
        });

        // Receiving the signalR response after deleting the website
        signalRConnection.on("WebsiteDelete", function (webId, created) {
            setDeleteWeb(webId);
        });

        if(userRole == 1) {
            setTableHeaders([
                { "name": "Site", "sort": true, "width": "200px", "sort_by": "site" },
                { "name": "URL", "sort": true, "width": "280px","sort_by": "url" },
                { "name": "Last Login", "sort": true, "width": "200px"  ,"sort_by": "lastlogin"},
                { "name": "DNS Configuration", "sort": false, "width": "200px" },
                { "name": "Actions", "sort": false, "width": "200px" }
            ]);
        } else {
            setTableHeaders([
                { "name": "Site", "sort": true, "width": "200px", "sort_by": "site" },
                { "name": "URL", "sort": true, "width": "280px","sort_by": "url" },
                { "name": "Last Login", "sort": true, "width": "200px"  ,"sort_by": "lastlogin"},
                { "name": "Actions", "sort": false, "width": "200px" }
            ]);
        }
    }, [])

    useEffect(() => {
        window.scroll(0, 0);
        dispatch(parseBreadcrumbsList(breadcrumbsList));
        const params = new URLSearchParams(location.search);
        const search = params.has('search') ? params.get('search') : '';
        var url = null
        search ? url = `/api/websites/list?search=${search}`: url = `/api/websites/list`;
        const sort = params.has('sort') ? params.get('sort') : ''
        const sort_order = params.has('sort_order') ? params.get('sort_order') : '';
        if(sort) {
            url = `/api/websites/list?sort_by=${sort}&sort_type=${sort_order}`
        } else if(sort && search) {
            url = `/api/websites/list?search=${search}&sort_by=${sort}&sort_type=${sort_order}`
        } else {
            url = `/api/websites/list`;
        }
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                getWebsite.GetWebsite(url, accesstoken, (data) => {
                    if (data.status == 200) {
                        setLoading(false);
                        setRoleList(data.data.data)
                        setCheckedState(new Array(data.data.data.length).fill(false))

                        getDownloadList(data.data.data);

                        const updatedCheckedState = data.data.data.map((item, index) => {
                            if(item.dnsAdded) {
                                return item.dnsAdded;
                            }
                        })
                
                        setCheckedState(updatedCheckedState);
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                })
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }, [deleteproject, downloadtype, issort, isCreated, isEditted, isUpdatedWeb, isDeletedWeb])

    const getDownloadList = (data) => {
        data.length > 0 && data.map((item) => {
            if(item.created == false) {
                item.siteUrl = "Websites creation in progress"
            } else {
                if(item.edit == true) {
                    item.siteUrl = "Websites updation in progress"
                } else if(item.delete == true) {
                    item.siteUrl = "Websites deletion in progress"
                }
            }
        })

        setDownloadList(data);
    }

    const EditWebsite = (event, websiteId) => {
        event.stopPropagation();

        // navigating to the Edit page
        navigate(`/websites/${websiteId}/edit`)     
    }

    const deleteRole = (event, id) => {
        event.stopPropagation();
        setDeleteProjectId(id);
        handleShow();
    }

    const handleStrapiRedirection = (event, details, index) => {
        if(checkedState[index] == true) {
            var url = `/api/websites/cmsdetails/${details.idWebsites}`;
            var sname = details.siteName.replace(/[^a-zA-Z0-9_]/g, '');
            function CallAPI(accesstoken) {
                if(accesstoken === '') {
                    navigate('/login');
                }
                else {
                    getWebsite.GetCmsDetails(url, accesstoken, (data) => {
                        if (data.status == 200) {
                            data.data.data.uri != "" && window.open(CMS_BASE_URL+"/"+sname+"/admin/auth/redirectlogin?tcr="+data.data.data.uri, "_blank");
                        } else if(data.status == 401) {
                            navigate("/login")
                        }
                    })
                }
            }
            RefreshToken((accesstoken) => CallAPI(accesstoken));
        }
    }

    const callSearchApi = (query) => {
        navigate(`/websites/list?search=${query}`)
        var url = `/api/websites/list?search=${query}`
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getWebsite.GetWebsite(url, accesstoken, (data) => {
                    if (data.status == 200) {
                        setLoading(false);
                        setRoleList(data.data.data);
                        setCheckedState(new Array(data.data.data.length).fill(false))

                        getDownloadList(data.data.data);

                        const updatedCheckedState = data.data.data.map((item, index) => {
                            if(item.dnsAdded) {
                                return item.dnsAdded;
                            }
                        })
                        setCheckedState(updatedCheckedState);
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                })
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }
    
    const NewWebsite = () => {
        navigate(`/websites/new`)
    }

    const handleCheckbox = (position, data) => {
        const updatedCheckedState = checkedState.map((item, index) => {
            if(position == index) {
                return !item;
            } else {
                return item;
            }
        })

        setCheckedState(updatedCheckedState);

        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                callEditWebsiteApi(data, accesstoken);
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    const callEditWebsiteApi = (data, accesstoken) => {
        const details = {
            IdWebsites: parseInt(data.idWebsites),
            SiteName: data.siteName,
            SiteUrl: data.siteUrl,
            BrandId: data.brandId,
            DnsAdded: true
        }
        getWebsite.EditWebsite(details, '/api/websites/edit', accesstoken, (data) => {
            if(data.status == 200) {
                setEditted(!isEditted)
            } else if(data.status == 401) {
                navigate("/login")
            }
        })  
    }

    const RedirectTo = (checkedState, index) => {
        console.log(checkedState[index])
        if(checkedState[index] != true) {
            setRedirect(true)
        }
    }

    const handleDisable = () => {
        setRedirect(false);
    }

    const handleEnable = () => {
        setRedirect(true);
    }

    return (
        <div className='websites-container'>
            <Header />
            <div className='row websites-section'>
                <Sidebar />
                <div className="col-10 website-page-section">
                    <div className="search-section-websites">
                        <Breadcrumbs />
                        <SearchSection values={searchValues} handleFilter="" setDownloadtype="" downloadtype=""
                        downloadarray={downloadList} headers={headers} filename={filename}
                        callSearchApi={(query) => callSearchApi(query)} navigateTo={NewWebsite} pageType="Websites"/>
                    </div>
                    {isLoading ? 
                    (<Spinner/>) : 
                    (<>
                    <div className="website-role-container">
                        <div className='table-view-container-website'>
                            <div id="print" className='list-items'>
                                <table>
                                    <thead>
                                        <tr className='heading-row'>
                                            {tableHeaders.map((item, index) => {
                                                return (
                                                    <>
                                                        <th className={index == 4 ? `heading-data${index} website-action-heading`: index == 3 ? `heading-data${index} dns-heading` : `heading-data${index}`} style={{ minWidth: `${item.width}`, textAlign: "left"}}>
                                                            <div className='flex-display'>
                                                                <div className='label'>{item.name}</div>
                                                                {item.sort &&
                                                                    (<div className='sort-arrows'>
                                                                        {
                                                                            !(sortValues.sortBy === item.sort_by && sortValues.sortType === 'asc') &&
                                                                            (<img className='uparrow' src={upsort} alt="uparrow" 
                                                                            data-sort-by={item.sort_by} data-sort-type='asc' onClick={(e) => handleSort(e.target.dataset)}></img>)                                                                                       
                                                                        }
                                                                        {
                                                                            !(sortValues.sortBy === item.sort_by && sortValues.sortType === 'desc') &&
                                                                            (<img className='downarrow' src={downsort} alt="downarrow"
                                                                            data-sort-by={item.sort_by} data-sort-type='desc' onClick={(e) => handleSort(e.target.dataset)}></img>)                                                                                        
                                                                        }
                                                                    </div>)} 
                                                            </div>                                  
                                                        </th>
                                                    </>
                                                )
                                            })}
                                        </tr>
                                    </thead>
                                    {
                                        rolelist.length === 0 ? <p className="no-result">No results found</p> :
                                        <tbody>
                                            {(rolelist) && rolelist.map((item, index) => {
                                                return (
                                                    <tr id={index} onMouseOver={(e) => addDarkImage(e, index)} onMouseLeave={(e) => removeDarkImage(e, index)} className="details-list-website">
                                                        <td className='data0'>{item.siteName != null && item.siteName}</td>
                                                        {
                                                            (item.created) ? 
                                                            (!item.edit ?  
                                                            (!item.delete ?  
                                                            <><td className='data1'><div onClick={() => RedirectTo(checkedState, index)}><a href={checkedState != null && checkedState[index] == true && 'http://'+item.siteUrl} target='_blank'>{item.siteUrl}</a></div></td>
                                                            <td className='data2'>{item.lastLogin && convertUTCToPST(item.lastLogin + 'Z', "updates")}</td>
                                                            {userRole == 1 && 
                                                            <td>
                                                                <div className="dns-configuration">
                                                                    <label class="switch">
                                                                        {checkedState != null && <input type="checkbox" checked={checkedState[index]} onChange={() => !item.dnsAdded && handleCheckbox(index, item)}/>}
                                                                        <span class="slider round"></span>
                                                                    </label>
                                                                </div>
                                                            </td>}
                                                            <td className='data7 website-action'>
                                                                {userRole == 1 && 
                                                                <Tooltip title="Edit Portal">
                                                                    <img id={`${'edit'+index}`} className='edit' src={edit} alt="edit" onClick={(event)=>EditWebsite(event, item.idWebsites)}></img>
                                                                </Tooltip>}
                                                                {userRole == 1 && 
                                                                <Tooltip title="Delete Portal">
                                                                    <img id={`${'trash'+index}`} className='trash' src={trash} alt="delete" onClick={(event)=>deleteRole(event,item.idWebsites)}></img>
                                                                </Tooltip>}
                                                                <Tooltip title="CMS Settings">
                                                                    <img id={`${'strapi-edit'+index}`} className='strapi-edit' src={starpiEdit} alt="edit" onClick={(event) => handleStrapiRedirection(event, item, index)}></img>
                                                                </Tooltip>
                                                            </td>
                                                            </> : <><td><div className="website-deletion"><p className="website-progress">Website deletion in progress</p></div></td><td></td><td></td><td></td></>) : 
                                                            <><td><div className="website-creation"><p className="website-progress">Website updation in progress</p></div></td><td></td><td></td><td></td></>) 
                                                            : <><td><div className="website-creation"><p className="website-progress">Website creation in progress</p></div></td><td></td><td></td><td></td></>
                                                        }
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    }
                                </table>
                            </div>
                        </div>
                    </div>
                    </>)}
                </div>
            </div>
            <Footer />
            <DeleteItem show={show} handleClose={handleClose} deleteApiCall={deleteContact} enable={true}/>
            <EnableDNS show={redirect} handleClose={handleDisable} page="websites"/>
        </div>
    );
}

export default Websites;